import React from "react";
import { Link } from "react-router-dom";
import MobileMenu from "../MobileMenu/MobileMenu";
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";

const Header = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <header id="header">
      <div className={" " + props.hclass}>
        <nav className="navigation navbar navbar-expand-lg navbar-light">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-lg-2 col-md-3 col-3 d-lg-none d-block">
                <div className="mobile-menu-left">
                  <MobileMenu />
                </div>
              </div>
              <div className="col-lg-2 col-md-6 col-6">
                <div className="navbar-header">
                  <Link className="navbar-brand" to="/">
                    <img src={props.Logo} alt="logo" />
                  </Link>
                </div>
              </div>
              <div className="col-lg-8 col-md-3 d-none d-lg-block">
                <div
                  id="navbar"
                  className="collapse navbar-collapse navigation-holder"
                >
                  <ul
                    className="nav navbar-nav mb-2 mb-lg-0 flex items-center gap-5 lg:gap-7 text-[15px] lg:text-[16px] font-medium ml-16 lg:ml-24"
                  >
                    <li
                      style={{
                        flexShrink: 0,
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Link onClick={ClickHandler} to="/">
                        Home
                      </Link>
                    </li>
                    <li
                      style={{
                        flexShrink: 0,
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Link onClick={ClickHandler} to="/about">
                        About Summit
                      </Link>
                    </li>
                    <li
                      style={{
                        flexShrink: 0,
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Link
                        onClick={ClickHandler}
                        to="/summit-objective"
                      >
                        Summit Objective
                      </Link>
                    </li>
                    <li
                      style={{
                        flexShrink: 0,
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Link
                        onClick={ClickHandler}
                        to="/sponsorship"
                      >
                        Sponsorship
                      </Link>
                    </li>
                    <li
                      style={{
                        flexShrink: 0,
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Link onClick={ClickHandler} to="/testimonials">
                        Testimonial
                      </Link>
                    </li>
                    <li
                      style={{
                        flexShrink: 0,
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Link onClick={ClickHandler} to="/gallery">
                        Gallery
                      </Link>
                    </li>
                    <li
                      style={{
                        flexShrink: 0,
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Link onClick={ClickHandler} to="/blog">
                        Blogs
                      </Link>
                    </li>
                    <li
                      style={{
                        flexShrink: 0,
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Link onClick={ClickHandler} to="/support">
                        Support
                      </Link>
                    </li>
                    <li
                      style={{
                        flexShrink: 0,
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Link onClick={ClickHandler} to="/contact">
                        Contact Us
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-3">
                <div className="header-right d-flex align-items-center justify-content-end">
                  <a href="tel:+919821261071" className="call-number">
                    <div className="icon">
                      <img src={props.telephone} alt="" />
                    </div>
                    <div className="text hotline-text" style={{ display: "none" }}>
                      <span className="title">Hotline 24/7</span>
                      <span className="number">+91 98212 61071</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

const mapStateToProps = (state) => {
  return {
    carts: state.cartList.cart,
  };
};

export default connect(mapStateToProps, { removeFromCart })(Header);
